import { baseUrlCC, baseUrlReward } from "@/shared/http/api";

export default {
    fetchAllRescuesInMoneyByPeriod: () => ({
        method: "GET",
        url: "api/v3/reports/partner/commissions-summary?page={page}&per_page={per_page}",
        baseURL: baseUrlCC,
    }),

    getAvailableForRedemption: () => ({
        method: "GET",
        url: "api/v1/partner-dash/balance-details?page={page}",
        baseURL: baseUrlReward,
    }),

    getCreditsUnderReview: () => ({
        method: "GET",
        url: "api/v1/partner-dash/points-to-be-released-details?page={page}",
        baseURL: baseUrlReward,
    }),

    getCreditsRescuedDetails: () => ({
        method: "GET",
        url: "api/v1/partner-dash/points-rescued-details",
        baseURL: baseUrlReward,
    }),
}